import { useState, useEffect, useRef, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import { useCompanyFlow } from "@/hooks/useCompanyFlow";
import * as _ from "lodash";
import logoPrincipal from "@/assets/imgs/logo.png";
import trashIcon from "@/assets/imgs/trash_icon.png";
import { ModalNotificaciones } from "../../../layouts/components/ModalNotificaciones";
import { ModalCarrito } from "../../../layouts/components/ModalCarrito";
import {
  useDataProductoBuscado,
  useDataProductoBuscadoByEmpresa,
} from "@/hooks/useProductos";
import { ModalMiCasa } from "../../../layouts/components/ModalMiCasa";
import { AddressButton } from "./AddressButton";
import { useAuth } from "@/_zustand/auth";
import { useMachine } from "@/_zustand/machine";
import { UserButton } from "./UserButton";
import { ModalProductoBuscado } from "./ModalProductoBuscado";
import { useFavoriteStore } from "@/_zustand/favorite";
import { useProductStore } from "@/_zustand/store";
import { productoBuscado, productoBuscadoByEmpresa } from "@/api/index";

export const NavbarNuevo = () => {
  const { empresa_id } = useMachine();
  const { products, productsByCompany, filterProductsByCompany } =
    useProductStore();
  const { pathname } = useLocation();
  const { isCompanyFlow, getCompanyRoute } = useCompanyFlow();

  useEffect(() => {
    filterProductsByCompany(empresa_id);
  }, [empresa_id, products, filterProductsByCompany]);

  const empresaId = empresa_id;

  const { mutate, data } = useDataProductoBuscado();
  const { mutate: mutateByEmpresa, data: dataByEmpresa } =
    useDataProductoBuscadoByEmpresa();
  const [showModal, setShowModal] = useState(false);
  const [showItems, setShowItems] = useState(false);
  const [showModalProductoBuscado, setShowModalProductoBuscado] =
    useState(false);
  const [showModalAddress, setShowModalAddress] = useState(false);
  const [searchItem, setSearchItem] = useState("");
  const [filteredItems, setFilteredItems] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const { userAddressName, statusAuth, user, userAddressTag, userAddress } =
    useAuth();
  const [tiendas, setTiendas] = useState([]);
  const { setViewFilter, viewFilter } = useFavoriteStore();
  const debounceRef = useRef(null);

  const notifications = [
    {
      title: "Nueva actualización",
      description: "Se ha publicado una nueva versión del sistema.",
    },
    {
      title: "Mensaje recibido",
      description: "Tienes un nuevo mensaje en tu bandeja de entrada.",
    },
    {
      title: "Evento programado",
      description: "Recordatorio: Reunión de equipo mañana a las 10 AM.",
    },
  ];

  const items = [
    {
      title: "Barquillería",
      articles: 2,
      distance: 13,
      store: "Tottus Plaza Oeste",
      address: "Av. Américo Vespucio 1501",
      image: "https://via.placeholder.com/58",
    },
    {
      title: "Móbil",
      articles: 2,
      distance: 13,
      store: "Tottus Plaza Oeste",
      address: "Av. Américo Vespucio 1501",
      image: "https://via.placeholder.com/58",
    },
    {
      title: "Shell Lubricantes",
      articles: 2,
      distance: 13,
      store: "Tottus Plaza Oeste",
      address: "Av. Américo Vespucio 1501",
      image: "https://via.placeholder.com/58",
    },
  ];

  useEffect(() => {
    // Cuando la data cambia (es decir, cuando la mutación fue exitosa)
    if (data && !isCompanyFlow) {
      try {
        // Asegúrate de que data.data existe (puede ser { status, data })
        const tiendas = Array.isArray(data) ? data : data.data || [];
        setTiendas(Array.isArray(tiendas) ? tiendas : []);
        setSearchItem("");
        setShowModalProductoBuscado(true);
      } catch (error) {
        console.error("Error procesando data en flujo normal:", error);
        setTiendas([]);
      }
    }
  }, [data, isCompanyFlow]);

  useEffect(() => {
    if (dataByEmpresa && isCompanyFlow) {
      try {
        // Asegúrate de que dataByEmpresa.data existe (puede ser { status, data })
        const tiendas = Array.isArray(dataByEmpresa)
          ? dataByEmpresa
          : dataByEmpresa.data || [];
        setTiendas(Array.isArray(tiendas) ? tiendas : []);
        setSearchItem("");
        setShowModalProductoBuscado(true);
      } catch (error) {
        console.error("Error procesando dataByEmpresa:", error);
        setTiendas([]);
      }
    }
  }, [dataByEmpresa, isCompanyFlow]);

  // Reiniciar buscador cuando cambia el flujo de empresa o la empresa
  useEffect(() => {
    setSearchItem("");
    setFilteredItems([]);
  }, [isCompanyFlow, empresa_id]);

  const jumpToReleventDiv = useCallback(
    (id, show) => {
      const element = document.getElementById(id);

      // 2. Check if the element exists
      if (element) {
        // 3. Only if the element exists, call the scroll method
        element.scrollIntoView({ behavior: "smooth" });
      } else {
        // Optional: Log an error or handle the case where the element is not found
      }
      setViewFilter(show);
    },
    [setViewFilter],
  );

  useEffect(() => {
    if (viewFilter === "favorites") {
      // Esto se ejecutará cada vez que viewFilter cambie a 'favorites'
      jumpToReleventDiv("tiendas", "favorites");
    } else jumpToReleventDiv("tiendas", "all");
  }, [viewFilter, jumpToReleventDiv]);

  const getCoords = () =>
    new Promise((resolve) => {
      if (userAddress?.length === 2) {
        resolve({ latitud: userAddress[0], longitud: userAddress[1] });
      } else if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (pos) =>
            resolve({
              latitud: pos.coords.latitude,
              longitud: pos.coords.longitude,
            }),
          () => resolve({ latitud: -33.45, longitud: -70.66 }),
          { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 },
        );
      } else {
        resolve({ latitud: -33.45, longitud: -70.66 });
      }
    });

  const handleInputChange = async (e) => {
    const searchTerm = e.target.value;
    setSearchItem(searchTerm);

    if (debounceRef.current) clearTimeout(debounceRef.current);

    if (!searchTerm || searchTerm.trim().length < 2) {
      setFilteredItems([]);
      return;
    }

    debounceRef.current = setTimeout(async () => {
      try {
        setIsSearching(true);
        const { latitud, longitud } = await getCoords();
        let resp;
        if (isCompanyFlow && empresaId) {
          resp = await productoBuscadoByEmpresa({
            search: searchTerm.trim(),
            latitud,
            longitud,
            empresa_id: empresaId,
          });
        } else {
          resp = await productoBuscado({
            search: searchTerm.trim(),
            latitud,
            longitud,
          });
        }
        const lista = Array.isArray(resp)
          ? resp
          : Array.isArray(resp?.data)
            ? resp.data
            : [];
        // Deduplicar por producto_id y extraer solo nombre+id para el dropdown
        const uniq = [];
        const seen = new Set();
        for (const item of lista) {
          if (!item?.producto_nombre) continue;
          const key = item.producto_id ?? item.producto_nombre;
          if (!seen.has(key)) {
            seen.add(key);
            uniq.push({
              producto_id: key,
              producto_nombre: item.producto_nombre,
            });
          }
        }
        setFilteredItems(uniq);
      } catch (err) {
        console.error("Error en búsqueda de sugerencias:", err);
        setFilteredItems([]);
      } finally {
        setIsSearching(false);
      }
    }, 300);
  };

  const handleItemClick = async (item) => {
    setSearchItem(item.producto_nombre);
    setFilteredItems([]);

    const { latitud, longitud } = await getCoords();
    if (isCompanyFlow) {
      mutateByEmpresa({
        search: item.producto_nombre,
        latitud,
        longitud,
        empresa_id: empresaId,
      });
    } else {
      mutate({ search: item.producto_nombre, latitud, longitud });
    }
  };

  // Rutas de autenticación donde no mostrar la barra de búsqueda
  const authRoutes = [
    "/login",
    "/register",
    "/forgot-password",
    "/recovery-password",
  ];
  const isAuthPage = authRoutes.some((route) => pathname.startsWith(route));

  return (
    <header className="navbar-new">
      <ModalNotificaciones
        notifications={notifications}
        show={showModal}
        handleClose={() => setShowModal(false)}
      />
      <ModalCarrito
        items={items}
        show={showItems}
        handleClose={() => setShowItems(false)}
      />
      <ModalMiCasa
        show={showModalAddress}
        handleClose={() => setShowModalAddress(false)}
        onSelect={() => {}}
      />
      <ModalProductoBuscado
        show={showModalProductoBuscado}
        setShow={setShowModalProductoBuscado}
        items={tiendas}
      />
      {/* Row Superior */}
      <div className="navbar-top">
        <div className="navbar-logo">
          <Link to={getCompanyRoute("/")}>
            <img
              className="d-inline-block align-text-top"
              src={logoPrincipal}
              alt=""
              width="100%"
              height="68"
            />
          </Link>
        </div>

        {!isAuthPage && (
          <div className="search-bar">
            <input
              type="text"
              value={searchItem}
              onChange={handleInputChange}
              placeholder="¿Qué necesitas hoy?"
            />
            {searchItem && (
              <img
                src={trashIcon}
                alt="Borrar"
                className="search-clear-icon"
                onClick={() => {
                  setSearchItem("");
                  setFilteredItems([]);
                }}
              />
            )}
            {isSearching && (
              <div
                className="search-suggestions"
                style={{ padding: "8px 16px", color: "#888" }}
              >
                Buscando...
              </div>
            )}
            {!isSearching && searchItem !== "" && _.size(filteredItems) > 0 && (
              <div className="form-control text-black montserrat-medium input-search search-suggestions">
                {filteredItems.map((item, index) => (
                  <li
                    key={item.producto_id ?? index}
                    onClick={() => handleItemClick(item)}
                  >
                    {item.producto_nombre}
                  </li>
                ))}
              </div>
            )}
          </div>
        )}

        {/* <button className="register-btn" onClick={() => setShowModalAddress(true)}>
          <i className="icon-location" ></i>
          <span>Mi casa</span>
        </button> */}
        {(statusAuth == "authed" || statusAuth == "valid") && (
          <AddressButton
            label={userAddressTag}
            address={userAddressName}
            onClick={() => setShowModalAddress(true)}
          />
        )}
        {!(statusAuth == "authed" || statusAuth == "valid") ? (
          <div className="auth-buttons">
            <button className="register-btn" type="button">
              <Link
                className="nav-link active mx-3"
                to={getCompanyRoute("login")}
              >
                Inicia sesión{" "}
              </Link>
            </button>
            <button className="register-btn" type="button">
              <Link
                className="nav-link active mx-3"
                to={getCompanyRoute("register")}
              >
                Regístrate{" "}
              </Link>
            </button>
          </div>
        ) : (
          <UserButton userName={user.usuario_nombre} />
        )}
        {isCompanyFlow ? (
          <div className="icons">
            <div className="cart-container">
              <span
                className="cart-icon"
                onClick={() => setShowItems(true)}
              ></span>
              {empresa_id && productsByCompany.length > 0 && (
                <span className="cart-notification">
                  {productsByCompany.length}
                </span>
              )}
            </div>
          </div>
        ) : (
          <div className="icons">
            <div className="cart-container">
              <span
                className="cart-icon"
                onClick={() => setShowItems(true)}
              ></span>
              {products.length > 0 && (
                <span className="cart-notification">{products.length}</span>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Row Inferior */}
      <nav className="navbar-bottom">
        <ul className="navbar-links">
          {(statusAuth == "authed" || statusAuth == "valid") &&
            !isCompanyFlow && (
              <>
                <li onClick={() => jumpToReleventDiv("tiendas", "all")}>
                  <Link
                    to="/#tiendas"
                    className="nav-link active mx-3"
                    aria-current="page"
                  >
                    Tiendas
                  </Link>
                </li>

                <li onClick={() => jumpToReleventDiv("tiendas", "favorites")}>
                  <Link
                    to="/#tiendas"
                    className="nav-link active mx-3"
                    aria-current="page"
                  >
                    Mis tiendas
                  </Link>
                </li>
              </>
            )}

          {(statusAuth == "authed" || statusAuth == "valid") && (
            <li>
              {" "}
              <Link className="nav-link active" to={getCompanyRoute("orders")}>
                Mis pedidos
              </Link>
            </li>
          )}
          {(statusAuth == "authed" || statusAuth == "valid") && (
            <li>
              <Link className="nav-link active" to={getCompanyRoute("profile")}>
                Mi perfil
              </Link>
            </li>
          )}
        </ul>
      </nav>
    </header>
  );
};
